import React from "react"
import { graphql, Link, navigate } from "gatsby"
import { Box, Flex, Grid, Heading } from "@chakra-ui/react"
import Layout from "../components/layouts/Layout"
import Feed from "../components/feeds/Feed"
import SEO from "../components/seo/SEO"

export default function Home({ data }) {

  const { experiences: { nodes: experienceList }, blogs: { nodes: blogList } } = data

  const onFeedTapped = (slug: string) => {
    navigate(slug)
  }

  return <>
    <SEO title="Home page" description="Home page" />
    <Layout>
      <Box mb={'6'}>

        {/* Experiences */}
        <Flex alignItems={'center'}>
          <Heading fontSize={'sm'} color={'gray.500'} pb={'4'} textTransform={'uppercase'}>Experiences</Heading>
          <Heading mt={'2'} ml={'auto'} justifySelf={'end'} fontSize={'sm'} pb={'4'} textTransform={'uppercase'}>
            <Link to={"/experiences"} >View all</Link>
          </Heading>
        </Flex>
        <Grid gridTemplateColumns={{ sm: '1fr', md: 'repeat(2,1fr)' }} gap={{ base: '4', md: '4' }}>
          {experienceList.map((content) => <Feed onFeedTapped={onFeedTapped} feed={content} />)}
        </Grid>

        {/* Log */}
        <Flex mt={'6'} alignItems={'center'}>
          <Heading fontSize={'sm'} color={'gray.500'} pb={'4'} textTransform={'uppercase'}>Logs</Heading>
          <Heading mt={'2'} ml={'auto'} justifySelf={'end'} fontSize={'sm'} pb={'4'} textTransform={'uppercase'}>
            <Link to={"/blogs"} >View all</Link>
          </Heading>
        </Flex>
        <Grid gridTemplateColumns={{ sm: '1fr', md: 'repeat(2,1fr)' }} gap={{ base: '4', md: '4' }}>
          {blogList.map((content) => <Box>
            <Feed feed={content} onFeedTapped={onFeedTapped} />
          </Box>)}
        </Grid>
      </Box>

    </Layout>
  </>
}

export const pageQuery = graphql`
  query HomeQuery {
    experiences: allMdx(
        limit: 6,
        filter: { frontmatter: { isLog: {eq: false } } },
        sort: { fields: [frontmatter___workDate], order: DESC}  
    ){
        nodes {
            excerpt(pruneLength: 120)
            id
            frontmatter {
                date(fromNow: true)
                title
                author
                workDate
                isLog
                tags
                place
                slug
            }
          }
    }

    blogs: allMdx(
      limit: 6,
      filter: { frontmatter: { isLog: {eq: true } } },
      sort: { fields: [frontmatter___date], order: DESC}  
  ){
      nodes {
          excerpt(pruneLength: 120)
          id
          frontmatter {
              date(fromNow: true)
              title
              author
              workDate
              isLog
              tags
              place
              slug
          }
        }
  }
  }
`